module.exports = __webpack_public_path__ + "img/banner.8c2caf93.png";